import I from "./objectWithoutPropertiesLoose.mjs";
import i from "./extends.mjs";
import * as h from "react";
import o from "./index180.mjs";
import { clsx as N } from "./clsx.mjs";
import C from "./ListContext.mjs";
import R from "./useThemeProps.mjs";
import O from "./styled.mjs";
import x, { getListItemTextUtilityClass as _ } from "./listItemTextClasses.mjs";
import { jsx as b, jsxs as $ } from "react/jsx-runtime";
import m from "./Typography.mjs";
import k from "./composeClasses.mjs";
const w = ["children", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"], B = (e) => {
  const {
    classes: r,
    inset: s,
    primary: n,
    secondary: c,
    dense: y
  } = e;
  return k({
    root: ["root", s && "inset", y && "dense", n && c && "multiline"],
    primary: ["primary"],
    secondary: ["secondary"]
  }, _, r);
}, E = O("div", {
  name: "MuiListItemText",
  slot: "Root",
  overridesResolver: (e, r) => {
    const {
      ownerState: s
    } = e;
    return [{
      [`& .${x.primary}`]: r.primary
    }, {
      [`& .${x.secondary}`]: r.secondary
    }, r.root, s.inset && r.inset, s.primary && s.secondary && r.multiline, s.dense && r.dense];
  }
})(({
  ownerState: e
}) => i({
  flex: "1 1 auto",
  minWidth: 0,
  marginTop: 4,
  marginBottom: 4
}, e.primary && e.secondary && {
  marginTop: 6,
  marginBottom: 6
}, e.inset && {
  paddingLeft: 56
})), g = /* @__PURE__ */ h.forwardRef(function(r, s) {
  const n = R({
    props: r,
    name: "MuiListItemText"
  }), {
    children: c,
    className: y,
    disableTypography: p = !1,
    inset: P = !1,
    primary: f,
    primaryTypographyProps: d,
    secondary: L,
    secondaryTypographyProps: j
  } = n, v = I(n, w), {
    dense: T
  } = h.useContext(C);
  let t = f ?? c, a = L;
  const u = i({}, n, {
    disableTypography: p,
    inset: P,
    primary: !!t,
    secondary: !!a,
    dense: T
  }), l = B(u);
  return t != null && t.type !== m && !p && (t = /* @__PURE__ */ b(m, i({
    variant: T ? "body2" : "body1",
    className: l.primary,
    component: d != null && d.variant ? void 0 : "span",
    display: "block"
  }, d, {
    children: t
  }))), a != null && a.type !== m && !p && (a = /* @__PURE__ */ b(m, i({
    variant: "body2",
    className: l.secondary,
    color: "text.secondary",
    display: "block"
  }, j, {
    children: a
  }))), /* @__PURE__ */ $(E, i({
    className: N(l.root, y),
    ownerState: u,
    ref: s
  }, v, {
    children: [t, a]
  }));
});
process.env.NODE_ENV !== "production" && (g.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Alias for the `primary` prop.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   * @default false
   */
  disableTypography: o.bool,
  /**
   * If `true`, the children are indented.
   * This should be used if there is no left avatar or left icon.
   * @default false
   */
  inset: o.bool,
  /**
   * The main content element.
   */
  primary: o.node,
  /**
   * These props will be forwarded to the primary typography component
   * (as long as disableTypography is not `true`).
   */
  primaryTypographyProps: o.object,
  /**
   * The secondary content element.
   */
  secondary: o.node,
  /**
   * These props will be forwarded to the secondary typography component
   * (as long as disableTypography is not `true`).
   */
  secondaryTypographyProps: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
const H = g;
export {
  H as default
};
//# sourceMappingURL=ListItemText.mjs.map
